import React, { Component } from 'react'
import Card8 from '../cards/Card8'
import HamburgerSvg from '../icons/HamburgerSvg'
import CodeSvg from '../icons/CodeSvg'
import FigmaSvg from '../icons/FigmaSvg'
import Design from '../icons/Design'
import PhoneSvg2 from '../icons/PhoneSvg2'
import WebServicesSvg from '../icons/WebServicesSvg'
import SMMsvg from '../icons/SMMsvg'
import ECommersSvg from '../icons/ECommersSvg'
import SeoSvg from '../icons/SeoSvg'
import RobotSvg from '../icons/RobotSvg'

import services from '../../actions/services.json'


const iconMap = {
    Design: <Design />,
    CodeSvg: <CodeSvg width="20" height="20" fill="#fff" />,
    FigmaSvg: <FigmaSvg width="20" height="20" fill="#fff" />,
    PhoneSvg2: <PhoneSvg2 width="20" height="20" fill="#fff" />,
    WebServicesSvg: <WebServicesSvg />,
    ECommersSvg: <ECommersSvg width="20" height="20" fill="#fff" />,
    SMMsvg: <SMMsvg />,
    SeoSvg: <SeoSvg width="20" height="20" fill="#fff" />,
    RobotSvg: <RobotSvg />




};

export class ServicesSection extends Component {
    render() {

        return (
            <section className='container bg-[#fff] p-[32px_0px]'>
                <div className='flex flex-col gap-[30px]'>

                    {services.map((service) => (
                        <Card8
                            key={service?.id}
                            icon={iconMap[service?.icon]} // Icon map-dən iconu seçirik
                            title={service?.title}
                            text={service?.text}
                            path={service?.path}
                        />
                    ))}

                </div>

            </section>
        )
    }
}

export default ServicesSection